// TeamCalendarContainer.js
import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import TeamIntegrationItem from './TeamIntegrationItem';
import { getIconComponent } from 'utils/icons/iconUtils';

const TeamCalendarContainer = ({
    searchTerm = '',
    subteamId = null,
    availableIntegrations = [],
    onIntegrationClick,
    isIntegrationConnected,
    getConnectionStatus
}) => {
    // Calendar Booking integrations: Chili Piper only
    const integrationNames = ['Chili Piper'];

    const filteredIntegrations = integrationNames
        .map(name => {
            const backendIntegration = availableIntegrations.find(
                i => i.name?.toLowerCase() === name.toLowerCase() ||
                    i.displayName?.toLowerCase() === name.toLowerCase()
            );

            if (backendIntegration) {
                return {
                    name: backendIntegration.displayName || backendIntegration.name,
                    _id: backendIntegration._id,
                    isConnected: isIntegrationConnected ? isIntegrationConnected(name) : false,
                    connectionStatus: getConnectionStatus ? getConnectionStatus(name) : 'disconnected'
                };
            }

            return {
                name: name,
                _id: null,
                isConnected: false,
                connectionStatus: 'disconnected'
            };
        })
        .filter(integration =>
            integration.name.toLowerCase().includes(searchTerm.toLowerCase())
        );

    if (filteredIntegrations.length === 0 && searchTerm) {
        return null;
    }

    return (
        <Box>
            <Typography
                variant="h5"
                sx={{
                    fontWeight: 600,
                    mb: 3,
                    color: '#242020',
                    fontSize: '2rem'
                }}
            >
                Calendar Booking
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    mb: 3,
                    color: '#828282'
                }}
            >
                Sync Touch lead data with your calendar manager to seamlessly book meetings with your leads
            </Typography>
            <Grid container spacing={2}>
                {filteredIntegrations.map((integration) => (
                    <Grid item xs={12} sm={6} md={3} key={integration.name}>
                        <TeamIntegrationItem
                            text={integration.name}
                            icon={getIconComponent(integration.name)}
                            onClick={() => onIntegrationClick && onIntegrationClick(integration.name)}
                            isConnected={integration.isConnected}
                            connectionStatus={integration.connectionStatus}
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default TeamCalendarContainer;

